module.exports = __webpack_public_path__ + "static/media/background-web_task-it.93db90fb.jpg";